import { h, Component } from 'preact';
import style from './index.less'

export default (props = {})=>(
    <div class={style.formEntry} style={props.style || {}}>
        {props.label && [
            <label>{props.label}</label>,
            <br />
        ]}
        {props.children}
    </div>
)


// WEBPACK FOOTER //
// ./components/elements/FormEntry/index.js